import { ITeaserContentType, ITeaserControlPoint } from 'types';

export const teaserContentTypes: ITeaserContentType[] = [
	{ id: 'GameLaunchVideo', name: 'contentTypeGameLaunchVideo' },
	{ id: 'GameLaunchImage', name: 'contentTypeGameLaunchImage' },
	{ id: 'AssistantVideo', name: 'contentTypeAssistantVideo' },
	{ id: 'AssistantImage', name: 'contentTypeAssistantImage' },
	{ id: 'AdvertisingVideo', name: 'contentTypeAdvertisingVideo' },
	{ id: 'AdvertisingImage', name: 'contentTypeAdvertisingImage' },
];

export const teaserControlPoints: ITeaserControlPoint[] = [
	{ id: 'Feedback', name: 'controlPointFeedback' },
	{ id: 'TipsPoint', name: 'controlPointTipsPoint' },
	{ id: 'WakeUp', name: 'controlPointWakeUp' },
	{ id: 'SendToKitchen', name: 'controlPointSentToKitchen' },
	{ id: 'GameCoupon', name: 'controlPointGameCoupon' },
	{ id: 'Payment', name: 'controlPointPayment' },
];
